<!--The content below is only a placeholder and can be replaced.-->
<div style="text-align:center">
  <site-manager></site-manager>
</div>
